import { apiURL, callAPI } from 'api/main';

import { groupByLanguages, middlewareSurveyQuestions } from './middleware';

export default async (id: number): Promise<ISurveyQuestion[]> => {
  try {
    const res = await callAPI({
      url: `${apiURL}/api/survey/questions/${id}?filter[language]=ignore`,
      method: 'GET',
      needToken: true,
    });

    const { data } = res.request;

    if (data) {
      return groupByLanguages(middlewareSurveyQuestions(data));
    }

    return [];
  } catch (ex) {
    return [];
  }
};
